import * as React from 'react';
import GamePageLayout from '../../../components/GamePageLayout';
import {navigate} from "gatsby-link";
import {useDispatch, useSelector} from "react-redux";
import {persist} from "../../../redux/actions";
import {STORAGE_KEY} from "../../../constants";
import GameHeader from "../../../components/GameHeader";
import appService from '../../../Service'
import {Button,Util,showLoading,closeDialog, showCustomDialog , showSuccessDialog , showErrorDialog} from "baziigram";
import {useEffect, useState} from "react";
import './styles.css'
import {LIFE_STONE_ACTION_PERSIST , LIFE_STONE_ACTION_CLEAR} from "../../../redux/LifeStone/lifeStone.constant.js"
import {CHAT_ACTION_PERSIST } from "../../../redux/Chat/chat.constant.js"
import {dictionary} from "../../../constants"
import {lifeStoneDictionary} from "../../../constants/lifeStone"
import {init  , getGroupsList , getJoinRequests,confirmLeaveGroup,requestToSync,syncMessages} from "../../../Handlers/Group"
import CreateGroup , {showGroupDialog} from "../../../Handlers/Group/CreateGroup"
import {showHelp , openForgetDialog} from "../../../Handlers/Dialogs"
import {UpdateUser , GetUser} from "../../../Util/user"
const LifeStonePage = () => {

  const { error  , levelInfo , user , levels , language , direction
   , isFirstTime , alternatives , showForgetDialog , group , hasNewMessage, chatId , hasNewRequest,isConnected   } = useSelector(state => state.lifeStone);
   const {  chats } = useSelector(state =>  state.chat);

   const gameId=46

  const dispatch = useDispatch();
  const updateState=(state)=>{
    dispatch(persist(state, LIFE_STONE_ACTION_PERSIST))

  }

  var gameanalytics = typeof window !== `undefined`? require('gameanalytics'):null;
  const isMounted = React.useRef(false)


  React.useEffect(async ()=>{
   let l = Util.getLanguage();
   updateState({isFirstTime:Util.Storage.get(STORAGE_KEY.IS_FIRST_TIME),language:l, direction:l=="fa"?"rtl":"ltr",
   levelInfo:null , user:GetUser() , showForgetDialog:false , levels:[] , isConnected:0 ,
    hasNewRequest:false , hasNewMessage:false , group:null })

   GetLevels()

  },[])


  useEffect(()=>{

      if((isFirstTime != 1 && isMounted.current) || isFirstTime==null )
         showHelp(viewHelp )

    // else if(isFirstTime==1 && isMounted.current   && showForgetDialog==true)
     // setTimeout(()=>openForgetDialog("phoenixForgetfulnessText"),500)

    if(isMounted.current==false)
    isMounted.current= true

  },[ isFirstTime , showForgetDialog ])


  useEffect(()=>{
    if(typeof window !== `undefined`) {
      gameanalytics.GameAnalytics.setEnabledInfoLog(true);
      gameanalytics.GameAnalytics.initialize("712c556d47699b5e1d7beb4e004716cc",
          "7838a8d082e4769dc7ddf99ea1f07fd3ab83322a");
    }


  },[])


  useEffect(() => {
    window.addEventListener('connectToHub',setGroup)
    window.addEventListener('sync',resetUser)
    window.addEventListener('syncMessages',receiveSyncedMessages)
    window.addEventListener('receiveMessage',receiveSyncedMessages)


    return () => {
      window.removeEventListener('connectToHub',setGroup)
      window.removeEventListener('sync',resetUser)
      window.removeEventListener('syncMessages',receiveSyncedMessages)
      window.removeEventListener('receiveMessage',receiveSyncedMessages)
      };
  }, []);

const receiveSyncedMessages=(e)=>{
if(typeof e.detail.lastUpdate == "undefined")
{
updateState({hasNewMessage:true})
return
}

 if(e.detail && e.detail.messages && (!chats[chatId] || e.detail.lastUpdate > chats[chatId].lastUpdate))
{
updateState({hasNewMessage:true})
let newChats = chats || {}
newChats[chatId] = {messages:e.detail.messages , lastUpdate:e.detail.lastUpdate}
dispatch(persist({chats:newChats }, CHAT_ACTION_PERSIST))
}

}

useEffect(() => {
   if(group && group.connected > 1  && isConnected==1 )
    {
       if(!user[chatId])
       requestToSync(group.name , gameId)
       else if(chats[chatId])
       syncMessages( chats[chatId].messages , chats[chatId].lastUpdate)
       else
       syncMessages( [] , 0)
    }

    if(isConnected==0 && gameId && group!=null )
        updateState({group:null})

  }, [group , isConnected]);


const resetUser=()=>{
let u=GetUser()
  updateState({user:u})
}


const setGroup = (e)=>{
if(e.detail && e.detail.name)
updateState({group:{...group,...e.detail} , chatId:e.detail.name+"-"+gameId})

else
updateState({group:null  , chatId:null})
}





  const goToGame=(route)=>{
    if(typeof window !== `undefined`) {
      let game = route.split("?gameId=")[1].split("&")[0]
      gameanalytics.GameAnalytics.addProgressionEvent(gameanalytics.EGAProgressionStatus.Start,
          game, null, null, user);
    }
    navigate("/WebView",{state:{url:route , backUrl:"/Game/LifeStone"}})
  }

 const GetLevels=()=>{
 updateState({error:null})
     appService.GetLevels(gameId).then(res=>{
     updateState({ levels:res.list.sort((a,b)=>b.id - a.id) })
     GetLevelInfo()
     }).catch(err=>{
     updateState({error:dictionary.retryText[language]})
     })
 }

  const GetLevelInfo=()=>{
  showLoading(true)
    appService.GetLevelInfo(gameId).then(res=>{
     // scrollToUserLevel()

      let newUser = {logo:3,levelInfo:{level:1}}
      if(res.user)
        {
          UpdateUser(res.user);
          newUser=GetUser();
          init(gameId,(connected)=>{updateState({isConnected:connected})});
        }

     updateState({levelInfo:res.currentLevel ,
      alternatives:res.alternatives , user:newUser , showForgetDialog:res.user ? false:true })

    }).catch(err=>{
    showErrorDialog(err.message || err)
    }).finally(res=>{
    showLoading(false)
    })
  }


  const makeFullScreen=(event)=>{
  let player = event.target;
  if (player.requestFullscreen)
          player.requestFullscreen();
      else if (player.webkitRequestFullscreen)
          player.webkitRequestFullscreen();
      else if (player.msRequestFullScreen)
        player.msRequestFullScreen();
  }

  const openDialog = ()=>{
     let body = <div style={{lineHeight:"30px"}} className={'d-flex flex-column align-items-center justify-content-between'}>
       <div>{levelInfo.title}</div>
      {levelInfo.logo && !levelInfo.videoLink && <img alt="level" height={"200px"} className="d-block" src={levelInfo.logo}/>}
      {levelInfo.videoLink && <video onPlaying={makeFullScreen}  id="videoplayer" poster={levelInfo.map}  controls>
        <source src={levelInfo.videoLink} type="video/mp4"/>
      Your browser does not support the video tag.
      </video>
      }
       {levelInfo.description && !levelInfo.videoLink && <div className={`${direction} text-dark px-3 my-2 ${direction=="rtl"?"text-right":"text-left"}` } dangerouslySetInnerHTML={{__html:levelInfo.description}}/>}

       {levelInfo.link && levelInfo.link!="" && <Button onClick={()=>{closeDialog();goToGame(levelInfo.link)}} title={dictionary.LetsGo[language]}></Button>}
         {(levelInfo.link==null || levelInfo.link=="") && <Button onClick={()=>{closeDialog()}} title={dictionary.close[language]}></Button>}

     </div>

    showCustomDialog(body)

  }



  const viewHelp=()=>{
    updateState({isFirstTime:1})
    Util.Storage.save(STORAGE_KEY.IS_FIRST_TIME,1)
    closeDialog()

  }




const scrollToUserLevel = ()=>{
    let element = document.getElementById(`g-${(user && user.levelInfo) ? user.levelInfo.level : 1}`)
       if(element)
        element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }

 const renderLevels=()=>{
    let items=[]
    let index = 0
   let isMobile = Util.Platform.checkMobileOrTablet()
   const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
   const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)

   let rowItemsCount = vh>vw ? 3 : 5
   let gamePerRow = vh>vw ? 2 : 3

   let rowsCount = Math.ceil(levels.length/gamePerRow)

      for(var i=0;i<rowsCount;i++)
      {
        let columns=[]
      for(var j=0;j<rowItemsCount;j++)
      {

      if(levels[index] && j%2==0){
      const game= levels[index]
       columns.push(<div   className={`col  my-4  mx-0 ${user && user.levelInfo && user.levelInfo.level  < game.id  ? "disable-level" : ""}`}>
                        <div onClick={()=>{

                           if(user && user.levelInfo && user.levelInfo.level  < game.id )
                           return

                           if(user && user.levelInfo && user.levelInfo.level== game.id)
                           openDialog()
                           else if( game.link && game.link!="")
                           goToGame(game.link)


                        }} id={`g-${levels[index].id}`}  className={`${(user && user.levelInfo && user.levelInfo.level>levels[index].id) ? 'userLevel' : 'grid-Items'}

                         d-flex flex-column align-items-center flex-wrap w-100`}>
                          <img alt="مرحله بازی" className={`game-Icons-square `} src={levels[index].logo}/>
                          <div className="mb-2 mt-4 d-flex flex-column justify-content-between align-items-center w-100 ">
                            <div className=" text-center w-100 mr-2"> {levels[index].title} </div>


                            </div>

                        </div>
                        {user && user.levelInfo && user.levelInfo.level == levels[index].id  &&  <div className="text-right mt-2 rtl text-warning d-flex flex-row justify-content-center align-items-center">
                        <img alt="you are here"
                            width="50px" height="50px"
                            className="ml-2 mt-2" src={`/images/profileImages/${user.logo}.png`}/>
                            {dictionary.youAreHere[language]}
                            </div> }

                      </div>)
                      index+=1;
                      }
          else if(j%2==1 && j!=0 && j!=rowItemsCount-1)
          columns.push(<div  class="col  my-4">
                               <div  className="d-flex flex-column justify-content-center  align-items-center">
                              <img alt="رد پا" className="foot-container" style={{transform:`rotate(${i%2==1?180:0}deg)`}}  src="/images/main-page/foot.png"/>
                               </div>
                             </div>)

      }
      let rowHtml= <div className={`row px-2 align-items-start justify-content-center ${i%2==0?'ltr':'rtl'}`} >
     {columns}
     </div>
       items.push(rowHtml)
       if(i!=rowsCount-1)
        {let endRowHTML=`<div  class="col  ">
                               <div  class="d-flex flex-column w-100 align-items-${i%2==0?'start':'end'}">
                                <img alt="رد پا" style='transform:rotate(90deg);' class="foot-container" src="/images/main-page/foot.png"/>
                                </div>
                                 </div>`

             let endRow= <div className={`row align-items-start justify-content-center`}
                   dangerouslySetInnerHTML={{__html: endRowHTML}}/>
       items.push(endRow)
       }
      }

   return items
 }

 const goToChat=()=>{
 navigate("/Game/Chat",{state:{gameId:gameId , group}})

 }



  return (
      <GamePageLayout  type={LIFE_STONE_ACTION_CLEAR}>
     <CreateGroup language={language} gameId={gameId}/>
      <div  className={"px-3 py-2 rtl"}  >
      <div className="top-menu d-flex flex-row">
    {!showForgetDialog && <>
    {group==null && <><button onClick={showGroupDialog} ><img className="life-stone-btn" src="/images/Group/createGroup (1).png"/></button>
     <button><img onClick={()=>getGroupsList(gameId)} className="life-stone-btn" src="/images/Group/groupsList.png"/></button></>}
     {group && user && <> <img className="ml-2" height="75px" width="60px" src={`/images/Group/flags/${group.flag}.png`}/>
     {group.role==0 && <button className="relative-position" onClick={()=>{getJoinRequests(gameId , group.name);updateState({hasNewRequest:false})}}>
     {hasNewRequest && <div className="notif">{dictionary.newRequests[language]}</div>}
     <img className="life-stone-btn" src="/images/Group/request.png"/></button>}
     <button className="relative-position" onClick={goToChat}>{hasNewMessage && <div className="notif">{dictionary.newMessages[language]}</div>}<img className="life-stone-btn" src="/images/Group/chat.png"/></button>
     <button onClick={()=>confirmLeaveGroup(gameId, group.name)}><img className="life-stone-btn" src="/images/Group/exitGroup.png"/></button>
                                          </>}
       </>}
      <button onClick={()=>navigate("/",true)}><img className="life-stone-btn" src="/images/Group/home.png"/></button>
      </div>
      {group && user && !showForgetDialog && <p  className="text-right w-100 mb-0">{group.name}</p>}
                   </div>
  <div  className="w-100 bottom-menu d-flex flex-row justify-content-center py-2 ">
                            <div style={{maxWidth:"300px"}} className="mx-1 rtl flex-fill" >
                                           <button
                                               className="life-stone-menu"
                                               type="button"
                                               onClick={() => {
                                                   navigate('/Game/Leaderboard' , {state:{gameId:gameId}})
                                               }}
                                           >
                                               <img alt={dictionary.leaderboard[language]} className="life-stone-icons" src={"/images/main-page/ranking.png"}/>
                                                {dictionary.leaderboard[language]}
                                                </button>

                                       </div>
                                       <div style={{maxWidth:"300px"}} className="mx-1 rtl flex-fill" >
                                           <button
                                               className="life-stone-menu"
                                               type="button"
                                               onClick={() => {
                                                   navigate('/Game/Store' , {state:{gameId:gameId}} )
                                               }}
                                           >
                                               <img alt={dictionary.store[language]} className="life-stone-icons" src={"/images/main-page/store.png"}/>
                                              {dictionary.store[language]}
                                               </button>

                                       </div>

                         {alternatives && alternatives.length>0  && <div style={{maxWidth:"300px"}} className="mx-1 rtl flex-fill" >
                                            <button
                                              className="life-stone-menu "
                                              type="button"
                                               onClick={()=>{navigate("/Game/OfferWall", {state:{gameId,alternatives,levelInfo}});}}
                                               >

                 <img  alt={dictionary.offerWall[language]} className="life-stone-icons" width="38px" height="38px"   src={"/images/main-page/merlin.png"}/>
                  {dictionary.offerWall[language]}
                          </button>
                            </div>
                            }
                           </div>
        <div  className={`${(group && !showForgetDialog) ? "life-stone-container-group" : "life-stone-container-single"}`}>
        <div className="h-100 ltr" style={{overflow:"auto"}}>
         <GameHeader>
         {levelInfo && levelInfo.headerText &&  <div className={"text_header text-center d-flex flex-column justify-content-center align-items-center"}>
                           <div className={"my-2"} dangerouslySetInnerHTML={{__html:levelInfo.headerText}}></div>
                         {levelInfo.link && <Button onClick={()=>{
                            if(isFirstTime != 1)
                              showHelp(viewHelp)
                            else
                            openDialog()}} title={dictionary.start[language]}></Button>}

                        </div>}
         </GameHeader>

          <div id={"levels"} className='main_container'>

            { error==null && (levels==null || levels.length==0)  && <div
                className={`baziigram-spinner my-5 spinner-border text-light`}
                role="status"
            ></div>}
            {error && <div className={"text-center text-warning "}>{error}
            <Button onClick={GetLevels} className={"mt-3"} title={dictionary.retry[language]}/>
            </div>}
            { error==null && <>

            <div className="grid-container rtl mb-0">

                {
                    levels && levels.length>0 && <>

                    {renderLevels()}</>
                }


            </div>
            </>}

             </div>
          </div>


        </div>

      </GamePageLayout>
  )
}

export default LifeStonePage;
